/* global define, google, window */

define('views/DrawingView',[
    'jquery',
    'underscore',
    'backbone',
    'text!templates/views/Drawing.html'
], function($, _, Backbone, template) {

    'use strict';

    var View = Backbone.View.extend({
        events: {
            'click .handButton': 'onHand',
            'click .circleButton': 'onCircle',
            'click .rectangleButton': 'onRectangle',
            'click .polygonButton': 'onPolygon',
            'click .cancelButton': 'onClearAll',
            'click .markersoffButton': 'onClearMarkers',
            'click .tooltipButton': 'onTooltip'
        },
        defaultShapeOptions: {
            editable: true,
            strokeColor: '#000000',
            strokeOpacity: 0.8,
            strokeWeight: 1,
            fillColor: '#08c',
            fillOpacity: 0.10,
        },
        initialize: function() {

            // Bind All
            _.bindAll(this);

            this.$window = $(window);
        },
        reset: function() {
            this.onHand();
            this.clearOverlay();
        },
        getMap: function() {
            return this.options.mapView.getMap();
        },
        resetButtons: function() {
            this.$handButton.removeClass('handButtonDown');
            this.$circleButton.removeClass('circleButtonDown');
            this.$rectangleButton.removeClass('rectangleButtonDown');
            this.$polygonButton.removeClass('polygonButtonDown');
        },
        onHand: function() {
            this.resetButtons();
            this.$handButton.addClass('handButtonDown');
            this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.HAND);
        },
        onCircle: function() {
            this.resetButtons();
            this.$circleButton.addClass('circleButtonDown');
            this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.CIRCLE);
        },
        onRectangle: function() {
            this.resetButtons();
            this.$rectangleButton.addClass('rectangleButtonDown');
            this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.RECTANGLE);
        },
        onPolygon: function() {
            this.resetButtons();
            this.$polygonButton.addClass('polygonButtonDown');
            this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
        },
        onClearAll: function() {
            this.trigger('clear-all');
        },
        onClearMarkers: function() {
            this.trigger('clear-markers');
        },
        render: function() {

            var map = this.getMap();

            this.$el.html(template);
            this.$handButton = this.$el.find('.handButton');
            this.$circleButton = this.$el.find('.circleButton');
            this.$rectangleButton = this.$el.find('.rectangleButton');
            this.$polygonButton = this.$el.find('.polygonButton');

            this.drawingManager = new google.maps.drawing.DrawingManager();
            this.drawingManager.setMap(map);
            this.drawingManager.setOptions({
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP,
                    drawingModes: [
                        google.maps.drawing.OverlayType.RECTANGLE,
                        google.maps.drawing.OverlayType.CIRCLE,
                        google.maps.drawing.OverlayType.POLYGON
                    ]
                },
                drawingControl: false,
                circleOptions: this.defaultShapeOptions,
                rectangleOptions: this.defaultShapeOptions,
                polygonOptions: this.defaultShapeOptions

            });

            // Listeners
            google.maps.event.addListener(this.drawingManager, 'overlaycomplete', this.onOverlaycomplete);
            
            this.resetButtons();
            this.onHand();


            var drawingManager = this.drawingManager;
            // FIX FOR Chrome
            this.$mapCanvas = $('#map_canvas');
            this.$mapCanvas.on('click', function() {
                if (drawingManager.getDrawingMode() !== google.maps.drawing.OverlayType.HAND) {
                    map.setZoom(map.getZoom() + 1);
                    map.setZoom(map.getZoom() - 1);
                }
            });



            return this;
        },
        update: function() {

            var $div = this.$el.find('.drawingView'),
                height = $div.height(),
                windowHeight = this.$window.height();

            $div.css('top', ((windowHeight / 2) - (height / 2)) + 'px');
        },
        hide: function() {

            if (this.overlay) {
                this.overlay.setMap(null);
                this.overlay = null;
            }

            this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.HAND);
            this.drawingManager.setMap(null);

            this.$el.hide();
            this.clearOverlay();

        },
        show: function() {
            this.drawingManager.setMap(this.getMap());
            this.$el.show();

        },
        onTooltip: function() {
            this.trigger('tour');
        },
        setOverlay: function(overlay) {

            if (this.overlay && this.overlay !== overlay) {
                this.overlay.setMap(null);
            }

            this.overlay = overlay;

            var _this = this;

            if (this.overlay) {

                this.getPolyInfo(this.overlay, function(type, points, spec) {
                    _this.trigger('change', '__free_poly_type', type);
                    _this.trigger('change', '__free_poly_spec', spec);
                    _this.trigger('change', '__free_poly_points', points);
                });

            } else {
                //this.clearOverlay();
                this.trigger('change', '__free_poly_type', '');
                this.trigger('change', '__free_poly_spec', '');
                this.trigger('change', '__free_poly_points', '');
            }

        },
        getOverlay: function() {
            return this.overlay;
        },
        zoomToOverlay: function() {

            if (!this.overlay) {
                return;
            }

            var bounds = new google.maps.LatLngBounds(),
                overlay = this.overlay;

            if (overlay instanceof google.maps.Circle) {
                bounds = overlay.getBounds();
            } else if (overlay instanceof google.maps.Rectangle) {
                bounds.extend(overlay.bounds.getSouthWest());
                bounds.extend(overlay.bounds.getNorthEast());
            } else if (overlay instanceof google.maps.Polygon) {

                var path = overlay.getPath();

                for (var i = 0; i < path.length; i++) {
                    bounds.extend(path.getAt(i));
                }
            }

            this.trigger('map-fit-bounds', bounds);
        },
        onOverlaycomplete: function(event) {

            var _this = this;

            // This is used for edits
            if (event.overlay.getPath) {
                google.maps.event.addListener(event.overlay.getPath(), 'set_at', function() {
                    _this.setOverlay(event.overlay);
                });
                google.maps.event.addListener(event.overlay.getPath(), 'insert_at', function() {
                    _this.setOverlay(event.overlay);
                });
            } else {
                google.maps.event.addListener(event.overlay, 'bounds_changed', function() {
                    _this.setOverlay(event.overlay);
                });
            }

            this.setOverlay(event.overlay);
            this.onHand();
        },
        clearOverlay: function() {
            this.setOverlay(null);
            this.trigger('change', '__free_poly_type', '');
            this.trigger('change', '__free_poly_spec', '');
            this.trigger('change', '__free_poly_points', '');
        },
        drawFreePoly: function(freePoly) {

            var options = this.defaultShapeOptions,
                shape = null,
                bounds = null,
                points = [],
                i = null;

            options.map = this.getMap();
            //options.editable = false;

            if (freePoly.type === 'polygon') {

                for (i = 0; i < freePoly.points.length; i = i + 2) {
                    points.push(new google.maps.LatLng(
                        freePoly.points[i],
                        freePoly.points[i + 1]
                    ));
                }

                options.path = points;

                shape = new google.maps.Polygon(options);

            } else if (freePoly.type === 'circle') {

                var firstPoint = null,
                    latLng = null;

                bounds = new google.maps.LatLngBounds();

                for (i = 0; i < freePoly.points.length; i = i + 2) {

                    latLng = new google.maps.LatLng(
                        freePoly.points[i],
                        freePoly.points[i + 1]);

                    if (!firstPoint) {
                        firstPoint = latLng;
                    }

                    bounds.extend(latLng);
                }

                var radius = google.maps.geometry.spherical.computeDistanceBetween(
                    bounds.getCenter(), latLng);

                options.center = bounds.getCenter();
                options.radius = radius;

                shape = new google.maps.Circle(options);

            } else if (freePoly.type === 'rect') {

                bounds = new google.maps.LatLngBounds();

                for (i = 0; i < freePoly.points.length; i = i + 2) {

                    bounds.extend(new google.maps.LatLng(
                        freePoly.points[i],
                        freePoly.points[i + 1]
                    ));

                }

                options.bounds = bounds;

                shape = new google.maps.Rectangle(options);

            } else {
                console.error('unsupported shape: ' + freePoly.type);
            }

            if (shape) {

                var _this = this;

                // This is used for edits
                if (shape.getPath) {
                    google.maps.event.addListener(shape.getPath(), 'set_at', function(e) {
                        _this.setOverlay(shape);
                    });
                    google.maps.event.addListener(shape.getPath(), 'insert_at', function() {
                        _this.setOverlay(shape);
                    });
                }
                else {
                    google.maps.event.addListener(shape, 'bounds_changed', function() {
                        _this.setOverlay(shape);
                    });
                }

                this.setOverlay(shape);
            }

        },
        getPolyInfo: function(shape, callback) {

            if (!callback || !shape) {
                return;
            }

            var spec = '',
                points = '',
                type = '',
                i = 0;

            if (shape instanceof google.maps.Circle) {

                // TODO move this out
                var d2r = Math.PI / 180; // degrees to radians
                var r2d = 180 / Math.PI; // radians to degrees
                var earthsradius = 6377.83; // 6377.83 is the radius of the earth in miles
                var numberOfPoints = 32;
                var radius = shape.radius / 1000;
                var lat = shape.center.lat();
                var lng = shape.center.lng();

                // find the raidus in lat/lon
                var rlat = (radius / earthsradius) * r2d;
                var rlng = rlat / Math.cos(lat * d2r);
                var ex, ey = null;

                for (i = 0; i < numberOfPoints + 1; i++) // one extra here makes sure we connect the
                {
                    var theta = Math.PI * (i / (numberOfPoints / 2));
                    ex = lng + (rlng * Math.cos(theta)); // center a + radius x * cos(theta)
                    ey = lat + (rlat * Math.sin(theta)); // center b + radius y * sin(theta)
                    points += ey + ',' + ex + ',';
                }

                spec += shape.center.lat() + ',' + shape.center.lng() + ',';
                spec += shape.center.lat() + ',' + (shape.center.lng() + shape.radius) + ',';

                type = 'circle';
            } else if (shape instanceof google.maps.Rectangle) {

                spec += shape.bounds.getSouthWest().lat() + ',' + shape.bounds.getSouthWest().lng() + ',';
                spec += shape.bounds.getNorthEast().lat() + ',' + shape.bounds.getNorthEast().lng() + ',';

                points += shape.bounds.getSouthWest().lat() + ',' + shape.bounds.getSouthWest().lng() + ',';
                points += shape.bounds.getSouthWest().lat() + ',' + shape.bounds.getNorthEast().lng() + ',';
                points += shape.bounds.getNorthEast().lat() + ',' + shape.bounds.getNorthEast().lng() + ',';
                points += shape.bounds.getNorthEast().lat() + ',' + shape.bounds.getSouthWest().lng() + ',';

                type = 'rect';

            } else if (shape instanceof google.maps.Polygon) {

                var path = shape.getPath(),
                    point = null;

                for (i = 0; i < path.length; i++) {
                    point = path.getAt(i);
                    points += point.lat() + ',' + point.lng() + ',';
                }

                spec = points;
                type = 'polygon';
            }

            callback(type, points, spec);

        }

    });

    return View;
});

